import { useScrollReveal } from "../../../hooks/useScrollReveal";

const stats = [
  { num: "100%", label: "Lead capture rate" },
  { num: "3×", label: "Faster follow-up speed" },
  { num: "40%", label: "Reduction in manual work" },
  { num: "24/7", label: "Automated operations" },
];

export default function StatsSection() {
  const { ref, visible } = useScrollReveal(0.15);

  return (
    <section className="w-full bg-[#050507] py-24 px-6 border-y border-white/[0.06]">
      <div
        ref={ref as React.RefObject<HTMLDivElement>}
        className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-0"
      >
        {stats.map((stat, i) => (
          <div
            key={stat.label}
            className={`flex flex-col items-center text-center py-12 px-6 ${
              i < stats.length - 1 ? "border-r border-white/[0.06]" : ""
            }`}
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? "translateY(0)" : "translateY(30px)",
              transition: `opacity 0.8s ease ${i * 0.12}s, transform 0.8s ease ${i * 0.12}s`,
            }}
          >
            <span
              className="font-black text-[#4ADE80] leading-none tracking-[-0.04em] mb-3"
              style={{
                fontFamily: "'Space Grotesk', sans-serif",
                fontSize: "clamp(3rem, 5vw, 5rem)",
              }}
            >
              {stat.num}
            </span>
            <span
              className="text-xs font-medium uppercase tracking-[0.12em] text-white/35"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              {stat.label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
